module.exports = __webpack_public_path__ + "static/media/edu-doc-yellow-bg.1d721462.png";